<template>
  <div>
    <h4>All Nodes Spreadsheet.</h4>
    <table :key="tableKey" class="w-100">
      <tr v-for="key in Object.keys(data)" :key="key">
        <td>{{$utils.camelCaseToSentence(key)}}</td>
        <td class="text-right">
          <i v-if="!data[key].loaded" class="fa fa-spinner fa-spin p-2"></i>
          <i v-else class="fa fa-check p-2"></i>
        </td>
      </tr>
    </table>
    <div class="text-center">
      <button class="btn btn-warning mr-3" @click="$emit('done')">Cancel</button>
      <button v-if="ready && !error" class="btn btn-success" @click="download()">Download</button>
      <button v-if="!ready && !error" class="btn" disabled>Preparing...</button>
      <div v-if="error" class="text-danger pt-3">{{error}}</div>
    </div>
  </div>
</template>

<script>
import XLSX from "xlsx";
import SpreadsheetUtils from "@/spreadsheet-utils";

export default {
  name: "all-nodes-spreadsheet",
  components: {},
  props: ["company"],
  data: () => ({
    data: {},
    tableKey: "",
    ready: false,
    error: "",
    workbook: {}
  }),
  methods: {
    getNodes: async function(key) {
      const response = await this.$web.getNodeData(
        this.company.id,
        this.$consts.NODE_TYPE_MAP[key]
      );
      this.data[key].nodes = response.data;

      this.data[key].loaded = true;
      this.tableKey = new Date().getMilliseconds().toString();
      if (this.areAllReady()) {
        this.createSpreadsheet();
      }
    },
    downloadData: async function() {
      for (let key in this.data) {
        this.data[key].data = await this.getNodes(key);
      }
    },
    areAllReady: function() {
      var allReady = true;
      for (let key in this.data) {
        if (!this.data[key].loaded) {
          allReady = false;
        }
      }
      return allReady;
    },
    createSpreadsheet: function() {
      try {
        var workbook = XLSX.utils.book_new();

        for (let key in this.data) {
          let nodeList = this.data[key].nodes;

          let rows = [];
          if (nodeList.length > 0) {
            let attrs = Object.keys(nodeList[0]);
            let excludedCategories = ["node", "location"];
            attrs = attrs.filter(attr => !excludedCategories.includes(attr));
            rows.push([
              "Location",
              "Building",
              "Floor",
              "Room",
              ...attrs.map(attr => this.$utils.camelCaseToSentence(attr))
            ]);
            for (let index in nodeList) {
              let vals = [
                nodeList[index].location.title,
                nodeList[index].node.building,
                nodeList[index].node.floor,
                nodeList[index].node.room,
                ...attrs.map(attr => nodeList[index][attr])
              ];
              rows.push(vals);
            }
          } else {
            rows = [["No nodes for this type"]];
          }

          let ws_data = [...rows];

          let ws = XLSX.utils.aoa_to_sheet(ws_data);
          XLSX.utils.book_append_sheet(
            workbook,
            ws,
            this.$utils.camelCaseToSentence(key)
          );
        }

        this.workbook = workbook;
        this.ready = true;
      } catch (err) {
        console.log(err);
        this.error = "An error occurred.";
      }
    },
    download: function() {
      SpreadsheetUtils.downloadWorkbook(
        this.workbook,
        "Nodes - " + this.company.name
      );
      this.$emit("done");
    }
  },
  async mounted() {
    this.$consts.node_types.forEach(nodeType => {
      this.data[nodeType] = { label: nodeType, data: [], loaded: false };
    });
    this.tableKey = new Date().toString();
    this.downloadData();
  }
};
</script>

<style scoped>
.btn:disabled {
  cursor: wait;
}
</style>
